export function isSessionCriticalQuery(queryKey: readonly unknown[]) {
  const path = queryKey.filter((part): part is string => typeof part === "string").join(".");
  return path.includes("auth.me") || path.includes("sessions.getIdleTimeout");
}

export function shouldEvictInactiveQuery({ queryKey, observerCount, updatedAt, now }: { queryKey: readonly unknown[]; observerCount: number; updatedAt: number; now: number }) {
  return observerCount === 0 && !isSessionCriticalQuery(queryKey) && now - updatedAt > 10 * 60 * 1000;
}
